"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
function queryBuilder(args) {
    var type = args.type ? args.type : 'query';
    var operation = args.operation ? args.operation : '';
    var properties = args.properties ? args.properties : [];
    var data = args.data ? args.data : {};
    var variables = args.variables ? args.variables : {};
    return {
        query: "\n\n      " + type + " " + operation + mapType(data) + " {\n        " + operation + mapArgument(data) + " {\n        " + properties.join('\n') + "\n      }\n    }\n",
        variables: tslib_1.__assign({}, data, variables),
    };
}
exports.queryBuilder = queryBuilder;
function mapArgument(data) {
    if (data === void 0) { data = {}; }
    return lodash_1.keys(data).length
        ? "(" + lodash_1.keys(data).reduce(function (dataString, key, i) {
            return "" + dataString + (i !== 0 ? ' ' : '') + key + ": $" + key;
        }, '') + ")"
        : '';
}
function mapType(data) {
    return lodash_1.keys(data).length
        ? "(" + lodash_1.keys(data).reduce(function (dataString, key, i) {
            return "" + dataString + (i !== 0 ? ', ' : '') + "$" + key + ": " + queryDataType(data[key]);
        }, '') + ")"
        : '';
}
function queryDataType(data) {
    switch (typeof data) {
        case 'object':
            var type = data._type;
            delete data._type;
            return type;
        case 'boolean':
            return 'Boolean';
        case 'number':
            return data % 1 === 0 ? 'Int' : 'Float';
        case 'string':
        default:
            return 'String';
    }
}
